import { AnalysisCriteriaAlert } from '@/features/analyses/components';
import { ProposalInteractionsTimeline } from './proposal-interactions-timeline.component';

interface Step3InteractionsProps {
  proposalId: string;
  underwritingMessages: string[];
}

export function Step3Interactions({
  proposalId,
  underwritingMessages,
}: Step3InteractionsProps) {
  return (
    <div className='flex flex-col gap-6'>
      <AnalysisCriteriaAlert messages={underwritingMessages} />

      <div className='flex flex-col gap-8 bg-white shadow-xl rounded-2xl py-12 px-8'>
        <ProposalInteractionsTimeline proposalId={proposalId} />
      </div>
    </div>
  );
}
